// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"df7b6517","453":"0c961185"}[chunkId] + ".chunk.js";
};